module.exports = {
      id: "tree-usage",
      viewBox: "0 0 218 334",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#tree-usage",
      toString: function () {
        return this.url;
      }
    }